import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import React from "react";
import { connect } from "react-redux";
import "./../main.scss";
import "./table.scss";
import checkJwt from "./../../../Global/jwtChecker";
import logout from "./../../../Global/logout";
import Loader from "./../../../Global/loader";
import toPdfConvertor from "./toPdf";
import { RiFileExcel2Line } from "react-icons/ri";
import { AiOutlineFilePdf } from "react-icons/ai";
import AllIzvjestajToExcel from "./AllIzvjestajToExcel";

export class Main extends React.Component {
    constructor(props) {
        super(props);

        this.toggleInvoiceVisibility = this.toggleInvoiceVisibility.bind(this);

        this.state = {
            loading: true,
            error: false,

            columns: [
                {
                    dataField: "businessPremisesLabel",
                    text: "Poslovni prostor",
                    style: { wordWrap: "break-word" },
                    headerStyle: { wordWrap: "break-word" },
                },
                {
                    dataField: "cardAmount",
                    text: "Kartični iznos",
                    isDummyField: true,
                    style: { textAlign: "right", wordWrap: "break-word" },
                    headerStyle: { wordWrap: "break-word" },
                    formatter: (cellContent, row) => {
                        var dateParser =
                            /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                        var match = row.firstInvoiceTime.match(dateParser);
                        var date = new Date(
                            match[3], // year
                            match[2] - 1, // monthIndex
                            match[1], // day
                            match[4], // hours
                            match[5], // minutes
                            match[6] //seconds
                        );
                        return (
                            <div key={Math.random()}>
                                {Intl.NumberFormat("hr", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                }).format(row.cardAmount)}{" "}
                                {date.getFullYear() >= 2023 ? "eur" : "kn"}
                            </div>
                        );
                    },
                },
                {
                    dataField: "cashAmount",
                    text: " Novčani iznos",
                    style: { textAlign: "right", wordWrap: "break-word" },
                    headerStyle: { wordWrap: "break-word" },
                    formatter: (cellContent, row) => {
                        var dateParser =
                            /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                        var match = row.firstInvoiceTime.match(dateParser);
                        var date = new Date(
                            match[3], // year
                            match[2] - 1, // monthIndex
                            match[1], // day
                            match[4], // hours
                            match[5], // minutes
                            match[6] //seconds
                        );
                        return (
                            <div key={Math.random()}>
                                {Intl.NumberFormat("hr", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                }).format(row.cashAmount)}{" "}
                                {date.getFullYear() >= 2023 ? "eur" : "kn"}
                            </div>
                        );
                    },
                },
                {
                    dataField: "theRestAmount",
                    text: "Ostali iznos",
                    style: { textAlign: "right", wordWrap: "break-word" },
                    headerStyle: { wordWrap: "break-word" },
                    formatter: (cellContent, row) => {
                        var dateParser =
                            /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                        var match = row.firstInvoiceTime.match(dateParser);
                        var date = new Date(
                            match[3], // year
                            match[2] - 1, // monthIndex
                            match[1], // day
                            match[4], // hours
                            match[5], // minutes
                            match[6] //seconds
                        );
                        return (
                            <div key={Math.random()}>
                                {Intl.NumberFormat("hr", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                }).format(row.theRestAmount)}{" "}
                                {date.getFullYear() >= 2023 ? "eur" : "kn"}
                            </div>
                        );
                    },
                },
                {
                    dataField: "totalAmount",
                    text: "Ukupno",
                    style: { textAlign: "right", wordWrap: "break-word" },
                    headerStyle: { wordWrap: "break-word" },
                    formatter: (cellContent, row) => {
                        var dateParser =
                            /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                        var match = row.firstInvoiceTime.match(dateParser);
                        var date = new Date(
                            match[3], // year
                            match[2] - 1, // monthIndex
                            match[1], // day
                            match[4], // hours
                            match[5], // minutes
                            match[6] //seconds
                        );

                        return (
                            <div key={Math.random()}>
                                {Intl.NumberFormat("hr", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                }).format(row.totalAmount)}{" "}
                                {date.getFullYear() >= 2023 ? "eur" : "kn"}
                            </div>
                        );
                    },
                },
            ],
        };
    }

    componentDidMount = async () => {
        this.props.mapState("CLIENT_MAP_LOADING_IZVJESTAJI", true);
        /*this.setState({
      loading: true
    })*/

        const unHashedJwt = await checkJwt();

        if (!unHashedJwt) {
            logout();
        }

        //await this.getInvoices()

        this.props.mapState("CLIENT_MAP_LOADING_IZVJESTAJI", false);
        /*
    this.setState({
        loading: false
    })    */
    };

    handleChange(e) {
        this.setState({
            [e.target.id]: e.target.value,
        });
    }

    seeRacun(racun) {
        this.setState({
            oneInvoice: racun,
            racunVisible: true,
        });
    }

    toggleInvoiceVisibility() {
        this.setState({
            oneInvoice: null,
            racunVisible: false,
        });
    }

    toPdf(data) {
        var currency =
            new Date(this.props.startDate).getFullYear() >= 2023
                ? " eur"
                : " kn";

        toPdfConvertor(
            data,
            this.props.startDate,
            this.props.endDate,
            currency
        );
    }

    saveAllToPdf = async () => {
        await AllIzvjestajToExcel(
            this.props.izvjestaji.invoicesOverview,
            this.props.startDateIzvjestaji,
            this.props.endDateIzvjestaji,
            this.props.businesssPremises
        );
    };

    render() {
        const expandRow = {
            parentClassName: "izvjestaj-row-expand-style",
            renderer: (row) => {
                var dateParser =
                    /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                var match = row.firstInvoiceTime.match(dateParser);
                var date = new Date(
                    match[3], // year
                    match[2] - 1, // monthIndex
                    match[1], // day
                    match[4], // hours
                    match[5], // minutes
                    match[6] //seconds
                );
                return (
                    <>
                        <div className="col">
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    Poslovni prostor:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.businessPremises}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    TID uređaja:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.deviceTid}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    ISU uređaja:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.deviceIsuNumber}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    Prvi račun:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.firstInvoice}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    {" "}
                                    Zadnji račun:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.lastInvoice}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    {" "}
                                    Datum prvog računa:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.firstInvoiceTime}
                                </div>
                            </div>
                            <div className="row">
                                <label
                                    htmlFor="PosBr"
                                    className="col-sm-4 col-form-label"
                                >
                                    {" "}
                                    Datum zadnjeg računa:
                                </label>
                                <div className="col-sm-8 text-left">
                                    {row.lastInvoiceTime}
                                </div>
                            </div>

                            <div className="row" style={{ padding: "10px" }}>
                                <table
                                    id="my-table"
                                    style={{ minWidth: "50%" }}
                                >
                                    <thead>
                                        <tr>
                                            <th>Porez</th>
                                            <th>Osnovica</th>
                                            <th>Iznos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {row.taxes.map((data, key) => (
                                            <tr key={key}>
                                                <td>
                                                    {Intl.NumberFormat(
                                                        "hr"
                                                    ).format(data.taxRate)}
                                                    %
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {Intl.NumberFormat("hr", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 2,
                                                    }).format(
                                                        data.taxBase
                                                    )}{" "}
                                                    {date.getFullYear() >= 2023
                                                        ? "eur"
                                                        : "kn"}
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {Intl.NumberFormat("hr", {
                                                        style: "decimal",
                                                        minimumFractionDigits: 2,
                                                    }).format(
                                                        data.taxAmount
                                                    )}{" "}
                                                    {date.getFullYear() >= 2023
                                                        ? "eur"
                                                        : "kn"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row" style={{ padding: "10px" }}>
                                <div
                                    className="btn btn-success"
                                    onClick={() =>
                                        this.toPdf(
                                            row,
                                            this.props.startDate,
                                            this.props.endDate
                                        )
                                    }
                                >
                                    <AiOutlineFilePdf
                                        size={20}
                                        style={{ color: "white" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                );
            },
        };

        return (
            <>
                {this.props.loading ? (
                    <div
                        style={{
                            position: "sticky",
                            marginTop: "50px",
                            left: "50%",
                        }}
                    >
                        <Loader />
                    </div>
                ) : this.props.izvjestaji.invoicesOverview ? (
                    <>
                        <div style={{ padding: "20px", textAlign: "center" }}>
                            <div
                                className="btn btn-glavnaBoja"
                                onClick={() => this.saveAllToPdf()}
                                style={{ fontSize: "14px" }}
                            >
                                <RiFileExcel2Line size={22} /> EXCEL
                            </div>
                        </div>
                        <BootstrapTable
                            keyField="businessPremisesUuid"
                            data={this.props.izvjestaji.invoicesOverview}
                            columns={this.state.columns}
                            expandRow={expandRow}
                            bodyStyle={{ wordBreak: "break-all" }}
                        />

                        <div
                            className="row"
                            style={{
                                margin: "0 auto",
                                paddingTop: "10px",
                            }}
                        ></div>
                    </>
                ) : (
                    <>
                        <div style={{ textAlign: "center", margin: "20px" }}>
                            <h1>{this.props.message}</h1>
                        </div>
                        <div></div>
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideToggled: state.clientSettings.asideToggled,
        izvjestaji: state.clientIzvjestaji.izvjestaji,
        startDate: state.clientIzvjestaji.startDate,
        endDate: state.clientIzvjestaji.endDate,
        loading: state.clientIzvjestaji.loadingIzvjestaji,
        message: state.clientIzvjestaji.message,
        businesssPremises: state.client.businesssPremises,
        startDateIzvjestaji: state.clientIzvjestaji.startDateIzvjestaji,
        endDateIzvjestaji: state.clientIzvjestaji.endDateIzvjestaji,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
        API: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
